<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)" size="small">
    <template #content>
      <h1 class="global-h1" :style="{ marginBottom: '15px', opacity: isUnbinding ? '0.5' : '1' }">Remove Content Source for this Topic?</h1>
      <div style="margin-bottom: 10px">You can choose a different album once this is removed.</div>
      <div><i>Note:</i> No content will be deleted.</div>
    </template>

    <template #footer="{ closeModal }">
      <div style="gap: 12px; display: flex; align-items: center">
        <SrpButton color="gray" fill="outlined" @click="closeModal" :isDisabled="isUnbinding">Cancel</SrpButton>

        <SrpButton
          @click="
            async () => {
              await unbind();
              closeModal();
            }
          "
          :isDisabled="isUnbinding"
        >
          <template #icon>
            <LoadingIcon v-if="isUnbinding" :size="20" />
            <IconEmbedded v-else name="scissors_2-5" :size="20" />
          </template>
          Remove
        </SrpButton>
      </div>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import ContentCalendarRepo from "@repos/ContentCalendarRepo";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

// Types
import { ContentCalendarItem } from "@contracts/contentCalendar";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    customerId: string;
    calendarItem: ContentCalendarItem;
  }>(),
  {}
);

const emit = defineEmits<{
  (e: "update:isVisible", isVisible: boolean): void;
  (e: "unbind", updatedCalendarItem: ContentCalendarItem): void;
}>();

// Handle unbinding ===========================================================
const isUnbinding = ref<boolean>(false);

async function unbind() {
  isUnbinding.value = true;

  const updatedCalendarItem = await ContentCalendarRepo.updateItem(props.customerId, {
    ...props.calendarItem,
    contentSource: null,
    contentSourceId: null,
    contentSourceMatches: null,
  } as ContentCalendarItem);

  isUnbinding.value = false;

  emit("unbind", updatedCalendarItem);
}
</script>
